module.exports = __webpack_public_path__ + "assets/cookieyes.f852ef9e.svg";